import { AgGridConfig } from '@approot/models';
import { Header } from '@approot/models/ag-grid.model';
import { ColumnApi } from 'ag-grid-community';

export function applyColumnState(columnApi: ColumnApi, columnState: any) {
  try {
    columnApi.applyColumnState({
      state: columnState,
      applyOrder: true
    });
  } catch (e) {
    console.error('Unable to load column state');
  }
}

export function mapHeaders(
  setting: AgGridConfig,
  globalDef: AgGridConfig
): Header[] {
  const defaultHeaders = globalDef.headers as Header[];
  return (setting.headers as string[])
    .map(headerName => {
      const h = defaultHeaders.find(header => header.field === headerName);
      if (!h) {
        console.warn(`Header ${headerName} not found in default headers`);
      }
      return h;
    })
    .filter(h => !!h);
}
